<template>
  <div>
    <el-container class="base-content" :direction="vertical">
      <el-header class="header" height="50px">
        <el-row>
          <el-col :span="6" :offset="0" class="left">
            <div class="img-box">
              <img src="https://api.hangehouse.com/static/87df76f1b5d73643bf8a43eb53694a1.png" alt="" class="img">
            </div>
            <span class="title">真会投资管理端—{{ managedTitle }}</span>
          </el-col>
          <el-col :span="14" :offset="0">
            <div class="menu-warp">
              <div class="menu" :class="{ active: plate == pl }" v-for="(pl, index) in plates" :key="index"
                @click="setPlate(pl)">{{ pl }}</div>
            </div>
          </el-col>
          <el-col class="right" :span="4" :offset="0">
            <span class="user">{{ user.group }}</span>
            <span class="user">{{ user.realName }}</span>
            <span class="logout" @click="logout">[退出]</span>
          </el-col>
        </el-row>
      </el-header>
      <el-container class="main-content" :direction="horizontal">
        <el-aside class="nav" width="200px" v-if="plate == '云招商' && permission['云招商']">
          <el-menu router :default-active="active_path" class="el-menu-vertical-demo menu" background-color="#545c64"
            text-color="#fff" active-text-color="#ffd04b">
            <el-menu-item index="/attract/project" v-if="permission['云招商'].indexOf('项目') > -1">
              <i class="el-icon-s-grid"></i>
              <span slot="title">项目</span>
            </el-menu-item>
            <el-menu-item index="/attract/house" v-if="permission['云招商'].indexOf('户型') > -1">
              <i class="el-icon-s-home"></i>
              <span slot="title">户型</span>
            </el-menu-item>
            <el-menu-item index="/attract/houseinfo" v-if="permission['云招商'].indexOf('房源') > -1">
              <i class="el-icon-s-home"></i>
              <span slot="title">房源</span>
            </el-menu-item>
            <el-menu-item index="/attract/user" v-if="permission['云招商'].indexOf('经纪人') > -1">
              <i class="el-icon-user-solid"></i>
              <span slot="title">经纪人</span>
            </el-menu-item>
            <!-- <el-menu-item index="/attract/banner"  v-if="permission['云招商'].indexOf('广告图')>-1">
                        <i class="el-icon-picture"></i>
                        <span slot="title">广告图</span>
                    </el-menu-item> -->
            <el-menu-item index="/setting" v-if="permission['云招商'].indexOf('设置') > -1">
              <i class="el-icon-setting"></i>
              <span slot="title">设置</span>
            </el-menu-item>
          </el-menu>
        </el-aside>
        <el-aside class="nav" width="200px" v-if="plate == '云项目' && permission['云项目']">
          <el-menu router :default-active="active_path" class="el-menu-vertical-demo menu" background-color="#545c64"
            text-color="#fff" active-text-color="#ffd04b">
            <el-menu-item index="/project/house" v-if="permission['云项目'].indexOf('楼盘') > -1">
              <i class="el-icon-s-home"></i>
              <span slot="title">楼盘</span>
            </el-menu-item>
            <el-menu-item index="/project/house-type" v-if="permission['云项目'].indexOf('户型') > -1">
              <i class="el-icon-s-release"></i>
              <span slot="title">户型</span>
            </el-menu-item>
            <el-menu-item index="/project/stick" v-if="permission['云项目'].indexOf('楼盘置顶') > -1">
              <i class="el-icon-caret-top"></i>
              <span slot="title">楼盘置顶</span>
            </el-menu-item>
            <el-menu-item index="/project/home-article" v-if="permission['云项目'].indexOf('首页资讯') > -1">
              <i class="el-icon-s-claim"></i>
              <span slot="title">首页资讯</span>
            </el-menu-item>
            <el-menu-item index="/project/collect" v-if="permission['云项目'].indexOf('用户跟进') > -1">
              <i class="el-icon-collection-tag"></i>
              <span slot="title">用户跟进</span>
            </el-menu-item>
            <el-menu-item index="/project/client" v-if="permission['云项目'].indexOf('客户') > -1">
              <i class="el-icon-collection-tag"></i>
              <span slot="title">客户</span>
            </el-menu-item>
            <el-menu-item index="/project/user" v-if="permission['云项目'].indexOf('置业顾问') > -1">
              <i class="el-icon-user-solid"></i>
              <span slot="title">置业顾问</span>
            </el-menu-item>
            <el-menu-item index="/project/city" v-if="permission['云项目'].indexOf('城市') > -1">
              <i class="el-icon-location"></i>
              <span slot="title">城市</span>
            </el-menu-item>
            <el-menu-item index="/project/dynamic" v-if="permission['云项目'].indexOf('文章') > -1">
              <i class="el-icon-s-claim"></i>
              <span slot="title">文章</span>
            </el-menu-item>
            <el-menu-item index="/project/article" v-if="permission['云项目'].indexOf('公众号推文') > -1">
              <i class="el-icon-s-help"></i>
              <span slot="title">公众号推文</span>
            </el-menu-item>
            <el-menu-item index="/project/official" v-if="permission['云项目'].indexOf('公众号') > -1">
              <i class="el-icon-s-management"></i>
              <span slot="title">公众号</span>
            </el-menu-item>
            <el-menu-item index="/project/setting" v-if="permission['云项目'].indexOf('设置') > -1">
              <i class="el-icon-setting"></i>
              <span slot="title">设置</span>
            </el-menu-item>
          </el-menu>
        </el-aside>
        <el-aside class="nav" width="200px" v-if="plate == '投资军团' && permission['投资军团']">
          <el-menu router :default-active="active_path" class="el-menu-vertical-demo menu" background-color="#545c64"
            text-color="#fff" active-text-color="#ffd04b">
            <el-menu-item index="/invest/tutor" v-if="permission['投资军团'].indexOf('导师团') > -1">
              <i class="el-icon-s-custom"></i>
              <span slot="title">导师团</span>
            </el-menu-item>
            <el-menu-item index="/invest/activity" v-if="permission['投资军团'].indexOf('活动') > -1">
              <i class="el-icon-receiving"></i>
              <span slot="title">活动</span>
            </el-menu-item>
            <el-menu-item index="/invest/question" v-if="permission['投资军团'].indexOf('问答') > -1">
              <i class="el-icon-question"></i>
              <span slot="title">问答</span>
            </el-menu-item>
            <el-menu-item index="/invest/survey" v-if="permission['投资军团'].indexOf('问卷调查') > -1">
              <i class="el-icon-c-scale-to-original"></i>
              <span slot="title">问卷调查</span>
            </el-menu-item>
            <el-menu-item index="/invest/welfare" v-if="permission['投资军团'].indexOf('金融产品') > -1">
              <i class="el-icon-s-marketing"></i>
              <span slot="title">金融产品</span>
            </el-menu-item>
            <el-menu-item index="/invest/paper" v-if="permission['投资军团'].indexOf('早报') > -1">
              <i class="el-icon-picture"></i>
              <span slot="title">早报</span>
            </el-menu-item>
            <el-menu-item index="/invest/prosperity">
              <i class="el-icon-picture"></i>
              <span slot="title">喜报</span>
            </el-menu-item>
            <el-menu-item index="/invest/foreclosure">
              <i class="iconfont">&#xe694;</i>
              <span slot="title">法拍房</span>
            </el-menu-item>
          </el-menu>
        </el-aside>
        <el-aside class="nav" width="200px" v-if="plate == '真会投资' && permission['真会投资']">
          <el-menu router :default-active="active_path" class="el-menu-vertical-demo menu" background-color="#545c64"
            text-color="#fff" active-text-color="#ffd04b">
            <!-- <el-menu-item index="/applet/banner"  v-if="permission['真会投资'].indexOf('首页广告图')>-1">
                            <i class="el-icon-picture"></i>
                            <span slot="title">首页广告图</span>
                        </el-menu-item>
                        <el-menu-item index="/applet/popupad"  v-if="permission['真会投资'].indexOf('首页弹窗广告')>-1">
                            <i class="el-icon-picture"></i>
                            <span slot="title">首页弹窗广告</span>
                        </el-menu-item>
                        <el-menu-item index="/applet/question-advertising"  v-if="permission['真会投资'].indexOf('问答广告图')>-1">
                            <i class="el-icon-picture"></i>
                            <span slot="title">问答广告图</span>
                        </el-menu-item>
                        <el-menu-item index="/applet/invest-banner"  v-if="permission['真会投资'].indexOf('投资军团广告图')>-1">
                            <i class="el-icon-picture"></i>
                            <span slot="title">投资军团广告图</span>
                        </el-menu-item> -->
            <el-menu-item index="/applet/member" v-if="permission['真会投资'].indexOf('成员管理') > -1">
              <i class="el-icon-user-solid"></i>
              <span slot="title">成员管理</span>
            </el-menu-item>
            <el-menu-item index="/applet/robot" v-if="permission['真会投资'].indexOf('机器人') > -1">
              <i class="el-icon-cpu"></i>
              <span slot="title">机器人</span>
            </el-menu-item>
            <el-menu-item index="/applet/advertising" v-if="permission['真会投资'].indexOf('广告位设置') > -1">
              <i class="el-icon-picture"></i>
              <span slot="title">广告位设置</span>
            </el-menu-item>
          </el-menu>
        </el-aside>
        <el-aside class="nav" width="200px" v-if="plate == '项目巡览' && permission['项目巡览']">
          <el-menu router :default-active="active_path" class="el-menu-vertical-demo menu" background-color="#545c64"
            text-color="#fff" active-text-color="#ffd04b">
            <el-menu-item index="/reallyWillBuy/tour" v-if="permission['项目巡览'].indexOf('项目巡览') > -1">
              <i class="el-icon-s-grid"></i>
              <span slot="title">项目巡览</span>
            </el-menu-item>
            <el-menu-item index="/reallyWillBuy/facilities" v-if="permission['项目巡览'].indexOf('项目配套') > -1">
              <i class="el-icon-s-fold"></i>
              <span slot="title">项目配套</span>
            </el-menu-item>
            
            <el-menu-item index="/reallyWillBuy/items" v-if="permission['项目巡览'].indexOf('预约订单') > -1">
              <i class="el-icon-postcard"></i>
              <span slot="title">预约订单</span>
            </el-menu-item>
            <el-menu-item index="/reallyWillBuy/Leaseclass" v-if="permission['项目巡览'].indexOf('办公分类') > -1">
              <i class="el-icon-s-unfold"></i>
              <span slot="title">企业定制</span>
            </el-menu-item>
            <el-menu-item index="/reallyWillBuy/officeProducts" v-if="permission['项目巡览'].indexOf('办公租赁') > -1">
              <i class="el-icon-s-cooperation"></i>
              <span slot="title">办公租赁</span>
            </el-menu-item>
            <el-menu-item index="/reallyWillBuy/enterprise" v-if="permission['项目巡览'].indexOf('办公产品') > -1">
              <i class="el-icon-star-on"></i>
              <span slot="title">企业服务</span>
            </el-menu-item>
            <el-menu-item index="/reallyWillBuy/member" v-if="permission['项目巡览'].indexOf('办公产品') > -1">
              <i class="el-icon-s-finance"></i>
              <span slot="title">会员福利</span>
            </el-menu-item>
            <el-menu-item index="/reallyWillBuy/memberorder" v-if="permission['项目巡览'].indexOf('办公产品') > -1">
              <i class="el-icon-s-ticket"></i>
              <span slot="title">会员券码</span>
            </el-menu-item>
            <el-menu-item index="/reallyWillBuy/shangban" v-if="permission['项目巡览'].indexOf('办公产品') > -1">
              <i class="el-icon-s-platform"></i>
              <span slot="title">商办资产</span>
            </el-menu-item>
          </el-menu>
        </el-aside>
        <el-container :direction="vertical">
          <el-main height="">
            <!-- Main content -->
            <slot></slot>
          </el-main>
        </el-container>
      </el-container>
    </el-container>
  </div>
</template>

<script>
export default {
  name: 'container',
  data () {
    return {
      vertical: 'vertical',
      horizontal: 'horizontal',
      user: '',
      plates: [],
      permission: {},
      patharr: {
        云招商: {
          项目: '/attract/project',
          户型: '/attract/house',
          房源: '/attract/houseinfo',
          经纪人: '/attract/user',
          设置: '/setting',
        },
        云项目: {
          楼盘: '/project/house',
          户型: '/project/house-type',
          楼盘置顶: '/project/stick',
          首页资讯: '/project/home-article',
          用户跟进: '/project/collect',
          客户: '/project/client',
          置业顾问: '/project/user',
          城市: '/project/city',
          文章: '/project/dynamic',
          公众号推文: '/project/article',
          公众号: '/project/official',
          设置: '/project/setting',
        },
        投资军团: {
          导师团: '/invest/tutor',
          活动: '/invest/activity',
          问答: '/invest/question',
          问卷调查: '/invest/survey',
          金融产品: '/invest/welfare',
          早报: '/invest/paper',
          喜报: '/invest/prosperity',
          法拍房: '/invest/foreclosure',
        },
        真会投资: {
          成员管理: '/applet/member',
          机器人: '/applet/robot',
          广告位设置: '/applet/advertising',
        },
        项目巡览: {
          项目巡览: '/reallyWillBuy/tour',
          项目配套: '/reallyWillBuy/facilities',
          // 预约订单: '/reallyWillBuy/bookAnOrder',
          项目订单: '/reallyWillBuy/items',
          企业定制:'/reallyWillBuy/Leaseclass',
          办公租赁:'/reallyWillBuy/officeProducts',
          企业服务:'/reallyWillBuy/enterprise',
          会员福利:'/reallyWillBuy/member',
          会员券码:'/reallyWillBuy/memberorder',
          商办资产:'/reallyWillBuy/shangban'
        },
      },
      managedCity: "",
    }
  },
  computed: {
    managedTitle () {
      if (this.managedCity === '全部') {
        return '总站'
      } else {
        return this.managedCity + '分站'
      }
    }
  },
  props: {
    active_path: {
      type: String,
      default: '/home'
    },
    plate: {
      type: String,
      default: '云招商',
    },
  },
  mounted () {
    this.user = this.$store.getters.getuser;
    if (this.user) {
      this.checkpermission();
    }
    let managedCity = this.$store.getters.getuser.city;
    this.managedCity = managedCity;
  },
  methods: {
    checkpermission () {
      const { permission } = this.user;
      this.permission = permission;
      const plates = Object.keys(permission).filter(key => permission[key].length > 0);
      this.plates = plates;

      // let { permission } = this.user;
      // this.permission = permission;
      // var plates = [];
      // for (var key in permission) {
      //   if (permission[key].length > 0) plates.push(key);
      // }
      // this.plates = plates;

    },
    setPlate (plate) {
      if (this.plate === plate) return;
      const pers = this.patharr[plate];
      let path = '';
      this.permission[plate].some(itemstr => {
        if (pers[itemstr]) {
          path = pers[itemstr];
          return true;
        }
      });
      this.$router.push({ path });

      // if (this.plate == plate) return;
      // var path = '', itemstr;
      // var pers = this.patharr[plate];
      // for (var i = 0; i < this.permission[plate].length; i++) {
      //   itemstr = this.permission[plate][i];
      //   if (pers[itemstr]) {
      //     path = pers[itemstr];
      //     break;
      //   }
      // }
      // this.$router.push({ path })
    },
    logout () {
      this.$confirm('是否确定退出').then(
        confirm => {
          this.$store.commit('settoken', '');
          this.$store.commit('setuser', '');
          this.$router.push({ path: '/' });
        },
        cancel => { }
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.header {
  background: #545c64;
  padding: 0 10rpx;
  text-align: left;
  color: #fff;
  border-bottom: 1px solid #f7f7f7;
  box-sizing: border-box;

  .left {
    overflow: hidden;

    .img-box {
      width: 48px;
      height: 48px;
      float: left;
      margin-right: 10px;

      .img {
        max-width: 48px;
        max-height: 48px;
      }
    }

    .title {
      line-height: 50px;
      float: left;
    }
  }

  .right {
    text-align: right;
    line-height: 50px;

    .user {
      margin-right: 20px;
    }

    .logout {
      cursor: pointer;
      color: rgb(231, 235, 14);
    }
  }
}

.base-content {
  display: flex;
  flex-direction: column;
  height: 100vh;

  .main-content {
    flex: 1;

    .nav {
      .menu {
        height: 100%;
        text-align: left;
      }
    }
  }
}

.menu-warp {
  display: flex;

  .menu.active {
    background: #fff;
    color: rgb(255, 208, 75);
    background-color: rgb(84, 92, 100);
  }

  .menu {
    width: 100px;
    line-height: 48px;
    text-align: center;
    cursor: pointer;
  }
}

.iconfont {
  margin-right: 5px;
  width: 24px;
  text-align: center;
  font-size: 18px;
  vertical-align: middle;
}
</style>